import type {OperationDashboardDto, OperationStateDto} from '@devmil/contracts';

import {usePanel} from '../../app/PanelProvider.js';

export interface OperationDashboardState {
  dashboard: OperationDashboardDto;
  operation: OperationStateDto;
}

export const useOperationDashboard = (): OperationDashboardState | null => {
  const {snapshot} = usePanel();
  if (!snapshot) {
    return null;
  }
  return {
    dashboard: snapshot.operationDashboard,
    operation: snapshot.operation,
  };
};
